import { Heart } from "lucide-react";
import { Link } from "react-router-dom";
import { useSocialLinks } from "@/hooks/useSocialLinks";

const SocialIcon = ({ platform }: { platform: string }) => {
  switch (platform) {
    case 'facebook':
      return (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
        </svg>
      );
    case 'instagram':
      return (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2" fill="none" />
          <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" fill="none" />
          <circle cx="18" cy="6" r="1" fill="currentColor" />
        </svg>
      );
    case 'twitter':
      return (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      );
    case 'linkedin':
      return (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z" />
          <rect x="2" y="9" width="4" height="12" />
          <circle cx="4" cy="4" r="2" />
        </svg>
      );
    case 'youtube':
      return (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z" />
          <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" fill="white" />
        </svg>
      );
    case 'tiktok':
      return (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
        </svg>
      );
    case 'pinterest':
      return (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 0C5.37 0 0 5.37 0 12c0 5.08 3.15 9.42 7.59 11.16-.1-.96-.19-2.44.04-3.5.21-.94 1.36-5.96 1.36-5.96s-.35-.7-.35-1.74c0-1.63.94-2.85 2.12-2.85 1 0 1.48.75 1.48 1.65 0 1-.64 2.5-.97 3.9-.28 1.17.59 2.12 1.75 2.12 2.1 0 3.71-2.21 3.71-5.41 0-2.83-2.03-4.8-4.93-4.8-3.36 0-5.33 2.52-5.33 5.12 0 1.01.39 2.1.88 2.69.1.12.11.22.08.34-.09.37-.29 1.17-.33 1.33-.05.22-.17.26-.39.16-1.46-.68-2.37-2.8-2.37-4.51 0-3.67 2.67-7.04 7.7-7.04 4.04 0 7.18 2.88 7.18 6.73 0 4.01-2.53 7.24-6.04 7.24-1.18 0-2.29-.61-2.67-1.33l-.73 2.77c-.26 1.02-.97 2.29-1.45 3.07C9.53 23.84 10.73 24 12 24c6.63 0 12-5.37 12-12S18.63 0 12 0z" />
        </svg>
      );
    case 'threads':
      return (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.96-.065-1.182.408-2.256 1.332-3.022.88-.73 2.088-1.146 3.496-1.208.966-.042 1.87.043 2.735.251l.001-.048c0-.946-.095-1.614-.357-2.138-.267-.534-.683-.872-1.343-1.091-.715-.239-1.634-.307-2.893-.216l-.147-2.123c1.526-.11 2.78-.039 3.831.305 1.054.345 1.86.96 2.394 1.828.541.878.784 2.003.784 3.435 0 .168-.003.346-.01.533.725.363 1.357.838 1.88 1.418.894.99 1.455 2.2 1.552 3.483.135 1.79-.422 3.513-1.57 4.856-1.825 2.135-4.532 3.218-8.048 3.218zm-1.504-7.09c-.642.028-1.178.163-1.55.39-.396.244-.567.536-.547.93.02.37.2.675.535.907.39.27.924.408 1.548.379.946-.042 1.68-.377 2.182-1.003.34-.425.564-.987.674-1.681-.64-.155-1.5-.252-2.389-.252-.153 0-.305.003-.453.01z" />
        </svg>
      );
    case 'bluesky':
      return (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364.136-.02.275-.039.415-.056-.138.022-.276.04-.415.06-3.912.56-6.387 2.78-4.20 5.59 2.037 2.62 3.909 3.81 5.386 4.12 1.457.31 2.777.21 2.777.21s1.32.1 2.777-.21c1.477-.31 3.35-1.5 5.386-4.12 2.188-2.81-.287-5.03-4.199-5.59-.14-.02-.278-.038-.416-.06.14.017.279.037.416.056 2.67.296 5.568-.628 6.382-3.364.246-.828.624-5.789.624-6.478 0-.69-.139-1.861-.902-2.206-.66-.298-1.664-.62-4.3 1.24C16.046 4.748 13.087 8.687 12 10.8z" />
        </svg>
      );
    default:
      return null;
  }
};

export const Footer = () => {
  const { links, loading } = useSocialLinks();

  return (
    <footer className="bg-primary text-primary-foreground py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Heart className="h-6 w-6 text-accent fill-accent/50" />
              <span className="text-xl font-bold">Living Tribute</span>
            </Link>
            <p className="text-primary-foreground/70 text-sm leading-relaxed mb-6">
              Create meaningful memorials, preserve every memory, celebrate every life.
            </p>
            {/* Social Icons */}
            {!loading && links.length > 0 && (
              <div className="flex gap-4">
                {links.map((link) => (
                  <a 
                    key={link.id}
                    href={link.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-9 h-9 rounded-full bg-primary-foreground/10 flex items-center justify-center hover:bg-primary-foreground/20 transition-colors"
                    aria-label={link.platform}
                  >
                    <SocialIcon platform={link.platform} />
                  </a>
                ))}
              </div>
            )}
          </div>
          
          {/* Product */}
          <div>
            <p className="font-semibold mb-4 text-sm uppercase tracking-wider">Product</p>
            <ul className="space-y-3">
              <li>
                <Link to="/why-living-tribute" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/plan-ahead" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm">
                  Plan Ahead
                </Link>
              </li>
              <li>
                <Link to="/gift" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm">
                  Gift a Tribute
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/see/example" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm">
                  Examples
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Support */}
          <div>
            <p className="font-semibold mb-4 text-sm uppercase tracking-wider">Support</p>
            <ul className="space-y-3">
              <li>
                <Link to="/resources" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/support" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm">
                  Support Center
                </Link>
              </li>
              <li>
                <Link to="/resources#getting-started" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm">
                  Getting Started
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Company */}
          <div>
            <p className="font-semibold mb-4 text-sm uppercase tracking-wider">Company</p>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm">
                  About
                </Link>
              </li>
              <li>
                <Link to="/partners" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm">
                  Partner Program
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors text-sm">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom bar */}
        <div className="border-t border-primary-foreground/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-primary-foreground/50 text-sm">
              © {new Date().getFullYear()} Living Tribute. Crafted with care.
            </p>
            <p className="text-primary-foreground/40 text-xs">
              Living Tribute • Create meaningful memorials, preserve every memory, celebrate every life.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
